'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/TextB.es.js";
const o = a.forwardRef((t, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...t, weights: e }));
o.displayName = "TextBIcon";
const n = o;
export {
  n as TextB,
  o as TextBIcon,
  o as TextBolderIcon
};
